import { takeLatest, put } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpPut, httpGet, responseIsSuccess, httpDelete } from 'core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { 
  bgCompanyLimitBankPath,
} from 'routes'

const createKeys = (key) => makeKeys(`BG_LIMIT_OF_BANK_REQUEST_${key}`)

const GET_LIST = createKeys('GET_LIST')
const GET_DETAIL = createKeys('GET_DETAIL')
const CREATE = createKeys('CREATE')
const UPDATE = createKeys('UPDATE')
const DELETE = createKeys('DELETE')
const PERMISSION = createKeys('PERMISSION')
const EXPORT = createKeys('EXPORT')
const GET_USAGE = createKeys('GET_USAGE')

export const getBGLimitOfBank = makeAction(GET_LIST.REQUEST, 'query')
export const getBGLimitOfBankDetail = makeAction(GET_DETAIL.REQUEST, 'id')
export const createBGLimitOfBank = makeAction(CREATE.REQUEST, 'data', 'history')
export const updateBGLimitOfBank = makeAction(UPDATE.REQUEST, 'data', 'history')
export const deleteBGLimitOfBank = makeAction(DELETE.REQUEST, 'id', 'history')
export const getBGLBPermission = makeAction(PERMISSION.REQUEST)
export const getBGLBExportDate = makeAction(EXPORT.REQUEST, 'query', 'onSuccess')
export const getBGLBUsage = makeAction(GET_USAGE.REQUEST, 'companyCode', 'bankName', 'changeUsage')

const getBGLimitOfBankSuccess = makeAction(GET_LIST.SUCCESS, 'data')
const getBGLimitOfBankDetailSuccess = makeAction(GET_DETAIL.SUCCESS, 'data')
const getBGLBPermissionSuccess = makeAction(PERMISSION.SUCCESS, 'data')
const getBGLBExportDateSuccess = makeAction(EXPORT.SUCCESS, 'data')

const apiPath = path => path ? urlWithPrefix(`bglimitofbank/${path}`) : urlWithPrefix('bglimitofbank')

function* getBGLimitOfBankRequest(action) {
  const { query } = action.payload

  try {
    yield put(appLoading('Loading Limit of Bank Data'))
    const response = yield httpGet(apiPath(), { ...query })
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGLimitOfBankSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Limit of Bank Error!'))
    }
    yield put(getBGLimitOfBankSuccess([]))
  }
}

function* getBGLimitOfBankDetailRequest(action) {
  const { id } = action.payload

  try {
    yield put(appLoading('Loading Limit of Bank Data'))
    const response = yield httpGet(apiPath(id))
    yield put(appLoaded())
    if (responseIsSuccess(response)) {
      if (response.data) {
        yield put(getBGLimitOfBankDetailSuccess(response.data))
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Load Limit of Bank Error!'))
    }
    yield put(getBGLimitOfBankDetailSuccess({}))
  }
}

function* createBGLimitOfBankRequest(action) {
  const { data, history } = action.payload

  try {
    yield put(appLoading('Create Limit of Bank.'))
    const response = yield httpPost(apiPath(), data)
    if (responseIsSuccess(response)) {
      yield put(appLoaded())
      yield put(toastSuccess('Create Limit of Bank success.'))
      history.push(bgCompanyLimitBankPath)
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Create Limit of Bank error!'))
    }
  }
}

function* updateBGLimitOfBankRequest(action) {
  const { data, history } = action.payload

  try {
    yield put(appLoading('Update Limit of Bank.'))
    const response = yield httpPut(apiPath(data.id), data)
    if (responseIsSuccess(response)) {
      yield put(appLoaded())
      yield put(toastSuccess('Update Limit of Bank success.'))
      history.push(bgCompanyLimitBankPath)
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Update Limit of Bank error!'))
    }
  }
}

function* getBGLBPermissionRequest() {
  try {
    const response = yield httpGet(apiPath('permission'))
    if (responseIsSuccess(response)) {
      if(response.data==1)
        yield put(getBGLBPermissionSuccess(true))
      else
        yield put(getBGLBPermissionSuccess(false))
    }
  } catch (e) {
    yield put(getBGLBPermissionSuccess(false))
  }
}

function* deleteBGLimitOfBankRequest(action) {
  const { id, history } = action.payload

  try {
    yield put(appLoading('Delete Limit of Bank.'))
    const response = yield httpDelete(apiPath(id))
    if (responseIsSuccess(response)) {
      yield put(appLoaded())
      yield put(toastSuccess('Delete Limit of Bank success.'))
      history.push(bgCompanyLimitBankPath)
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Delete Limit of Bank error!'))
    }
  }
}

function* getBGLBExportDateRequest(action) {
  const { query, onSuccess } = action.payload

  try {
    yield put(appLoading('Export Bank Guarantee Company Limit Of Bank Data'))
    const response = yield httpGet(apiPath('export'), { ...query })
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        yield put(getBGLBExportDateSuccess(response.data))
        if (onSuccess) onSuccess()
      }
    }
  } catch (e) {
    if (e && e.data && e.data.message) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Export Bank Guarantee Company Limit Of Bank Error!'))
    }
    yield put(getBGLBExportDateSuccess([]))
    yield put(appLoaded())
  }
}

function* getBGLBUsageRequest(action) {
  const { companyCode, bankName, changeUsage } = action.payload
  try {
    const response = yield httpGet(apiPath('usage'),{companyCode:companyCode, bankName:bankName})
    if (responseIsSuccess(response)) {
      changeUsage(response.data)
    }
  } catch (e) {
  }
}

export function* watchBGLimitOfBankSaga() {
  yield takeLatest(GET_LIST.REQUEST, getBGLimitOfBankRequest)
  yield takeLatest(GET_DETAIL.REQUEST, getBGLimitOfBankDetailRequest)
  yield takeLatest(CREATE.REQUEST, createBGLimitOfBankRequest)
  yield takeLatest(UPDATE.REQUEST, updateBGLimitOfBankRequest)
  yield takeLatest(DELETE.REQUEST, deleteBGLimitOfBankRequest)
  yield takeLatest(PERMISSION.REQUEST, getBGLBPermissionRequest)
  yield takeLatest(EXPORT.REQUEST, getBGLBExportDateRequest)
  yield takeLatest(GET_USAGE.REQUEST, getBGLBUsageRequest)
}

const initial = {
  lists: { data: [], loading: false },
  detail: { data:{} },
  permission: true,
  bgclbExport: { data: [], loading: false },
}

export default createReducer(initial, state => ({
  [GET_LIST.REQUEST]: () => ({
    ...state,
    lists: { data: [], loading: true }
  }),
  [GET_LIST.SUCCESS]: (data) => ({
    ...state,
    lists: { data: data.data, loading: false }
  }),
  [GET_LIST.FAILURE]: (data) => ({
    ...state,
    lists: { data: [], loading: false }
  }),
  [GET_DETAIL.REQUEST]: () => ({
    ...state,
    detail: { data: {}, loading: true }
  }),
  [GET_DETAIL.SUCCESS]: (data) => ({
    ...state,
    detail: { data: data.data, loading: false }
  }),
  [PERMISSION.REQUEST]: () => ({
    ...state,
    permission: state.permission
  }),
  [PERMISSION.SUCCESS]: (data) => ({
    ...state,
    permission: data.data
  }),
  [EXPORT.REQUEST]: () => ({
    ...state,
    bgclbExport: { data: [], loading: true }
  }),
  [EXPORT.SUCCESS]: (data) => ({
    ...state,
    bgclbExport: { data: data.data, loading: false }
  }),
}))